/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Bengio_TextInputs */

const en_home_quotes_bengio_text = /** @type {(inputs: Home_Quotes_Bengio_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rogue AI may be dangerous for the whole of humanity. Banning powerful AI systems (say beyond the abilities of GPT-4) that are given autonomy and agency would be a good start.`)
};

/**
* | output |
* | --- |
* | "Rogue AI may be dangerous for the whole of humanity. Banning powerful AI systems (say beyond the abilities of GPT-4) that are given autonomy and agency would..." |
*
* @param {Home_Quotes_Bengio_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_bengio_text = /** @type {((inputs?: Home_Quotes_Bengio_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Bengio_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_bengio_text(inputs)
});